module.exports = __webpack_public_path__ + "static/logoRobbins&Myers-692d1668a3ca33762c40450a2055c8cc.jpg";